<template>
  <div class="container">
      <carousel :per-page="4" :autoplay="true" :autoplaytimeout="3000" :loop="true" class="d-none d-sm-block">
          <slide v-for="id in laboratorios" :key="id">
            <div class="item-parceiro">
              <img :src="`${baseUrl}/redeImagem/codigo/${id}/logo`" 
                  class="img-fluid" alt="Laboratorio"
                  :onerror="`this.src='${require('@/img/icon-drachei.svg')}'`">
            </div>
          </slide>
        </carousel>

        <carousel :per-page="2" :autoplay="true" :autoplaytimeout="3000" :loop="true" class="d-block d-sm-none">
          <slide v-for="id in laboratorios" :key="id">
            <div class="item-parceiro">
              <img :src="`${baseUrl}/redeImagem/codigo/${id}/logo`" 
                  class="img-fluid" alt="Laboratorio"
                  :onerror="`this.src='${require('@/img/icon-drachei.svg')}'`">
            </div>
          </slide>
        </carousel>
      </div>
</template>
<script>
import * as http from 'axios'

export default {
  data () {
    return {
      unidades: [],
      laboratorios: [147, 17, 54, 62, 148, 163, 261, 263, 269, 316, 558, 578, 583, 590, 611, 628, 629, 635, 64, 103, 650, 721, 775, 781]
    }
  },

  computed: {
    baseUrl () {
      return http.defaults.baseURL
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/shared/SlickUnidades.vue